'use client';

import Sidebar from "@/components/admin/sidebar/Sidebar";
import TopHeader from "@/components/admin/header/TopHeader";
import Script from "next/script";
import {useEffect} from "react";
import {getLocalStorageValue} from "@/utils/localStorage";

export default function AdminLayout({children}) {
    const storedDataString = typeof window !== "undefined" ? localStorage.getItem("userLoggIn") : null;
    const user = getLocalStorageValue("userLoggIn");
    const userRole = user?.value?.role;
    useEffect(() => {
        let metaRobots = document.querySelector('meta[name="robots"]');
        if (!metaRobots) {
            metaRobots = document.createElement('meta');
            metaRobots.setAttribute('name', 'robots');
            document.head.appendChild(metaRobots);
        }
        metaRobots.setAttribute('content', 'noindex, nofollow');

        let metaGooglebot = document.querySelector('meta[name="googlebot"]');
        if (!metaGooglebot) {
            metaGooglebot = document.createElement('meta');
            metaGooglebot.setAttribute('name', 'googlebot');
            document.head.appendChild(metaGooglebot);
        }
        metaGooglebot.setAttribute('content', 'noindex, nofollow');
        
        if (storedDataString !== null) {
            try {
                const storedData = JSON.parse(storedDataString);
                if (new Date().getTime() > storedData.expiryTime) {
                    localStorage.removeItem("userLoggIn")
                    window.location.href = "/dang-nhap";
                }
            } catch (error) {
                console.error("Lỗi khi parse dữ liệu JSON:", error.message);
            }
        } else {
            window.location.href = "/dang-nhap";
        }
        document.body.classList.add('admin-page');
        return () => {
            document.body.classList.remove('admin-page');
        };
    }, [])

    return (
        <>
            <html lang="vi">
            <head>
                <meta charSet="UTF-8"/>
                <title>CRB Management</title>
                <link rel="icon" href="/img/fav.png"/>
                <link rel="stylesheet" href="/admin/css/bootstrap.min.css"/>
                <link rel="stylesheet" href="/admin/fonts/style.css"/>
                <link rel="stylesheet" href="/admin/css/main.css"/>
            </head>
            <body>
            <div className="page-wrapper">
                {/* Sidebar start */}
                <Sidebar userRole={userRole}/>
                {/* Sidebar end */}
                <div className="page-content">
                    {/* TopHeader start */}
                    <TopHeader userLoggIn={user}/>
                    {/* TopHeader end */}

                    {/* Main container start */}
                    <div className="main-container">{children}</div>
                </div>
            </div>
            {/* Main container end */}
            <Script src="/admin/js/jquery.min.js"></Script>
            {/* <Script src="/admin/js/bootstrap.bundle.min.js"></Script> */}
            <Script src="/admin/js/moment.js"></Script>
            <Script src="/admin/vendor/polyfill/polyfill.min.js"></Script>
            <Script src="/admin/js/main.js"></Script>
            </body>
            </html>
        </>
    );
}